module.exports = __webpack_public_path__ + "static/media/sana.875c4d23.webp";